import { ColumnVectorizer, } from './ColumnVectorizer';
// import { default as natural, } from 'natural';

/**
 * @namespace
 * @see {@link https://github.com/NaturalNode/natural} 
 */
export const nlp = Object.assign({
  ColumnVectorizer,
},
  // natural
);
